export default __webpack_public_path__ + "static/media/Link2.25f5208e.svg";